query ApprovalHistorySearch(
  $first: Int
  $after: Cursor
  $isHistorySearch: Boolean
  $approverUserId: UUID
  $filterApprovalId: UUID
  $isApproverUserApprover: Boolean
  $isApproverUserRequester: Boolean
  $isOnlyUnsignedApprovals: Boolean
  $isQueuedSearch: Boolean
  $searchRequest: SearchRequestInput
  $orderBy: [ApprovalHistoriesOrderBy!]
  $filter: ApprovalHistoryFilter
  $isLinkSearch: Boolean
) {
  approvalHistorySearch(
    first: $first
    after: $after
    searchRequest: $searchRequest
    isHistorySearch: $isHistorySearch
    approverUserId: $approverUserId
    filterApprovalId: $filterApprovalId
    isApproverUserApprover: $isApproverUserApprover
    isApproverUserRequester: $isApproverUserRequester
    isOnlyUnsignedApprovals: $isOnlyUnsignedApprovals
    isQueuedSearch: $isQueuedSearch
    orderBy: $orderBy
    filter: $filter
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      entityId
      approvalTopic
      urgencyLevel
      _isUrgentApproval
      entityApprovalBranchId
      entityApprovalBranchRowTimestamp
      approvalPersona
      additionalApprovalInformation
      _pendingApprovers
      approvalHistoryPhaseType {
        phaseName
      }
      _isValidating
      layoutType
      verificationLinkType {
        linkRouter
        linkHint
      }
      approvalHistoryApprover {
        requesterDate
        requesterName
        approvedDate
        approvers
        rejectedDate
        rejectors
        amendedDate
        amendedByName
      }

      _isAccountingEntryStampedCompleted
      _isTransactionCancelled
      _accountingStampUserName
      _accountingStampDate
      _accountingStampTransactionReference
      branchStatusType {
        approvalState
        statusType
      }
      iconType {
        iconType
        iconState
        isApprovalActionAvailable
      }
      isLevelBypassingAllowed
      companyCorporatePeriod {
        id
        startDate
        endDate
        _periodYear
      }
      description1
      description2
      description3
      date1
      amount1
      currency {
        isoCode
      }
      businessUnit {
        name
      }
      department {
        name
      }
      _isUserEnMasseApprovalAllowed
      isRequester
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
